export class JwtHelper {
  /**
   * Decodifica um token JWT sem verificar a assinatura
   * @param token Token JWT
   * @returns Payload decodificado ou null se inválido
   */
  static decodeToken(token: string): any {
    try {
      const base64Url = token.split('.')[1];
      if (!base64Url) {
        return null;
      }
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Erro ao decodificar token JWT:', e);
      return null;
    }
  }

  /**
   * Verifica se o usuário é conferidor baseado no token JWT
   * @param token Token JWT
   * @returns true se isConferidor === 1, false caso contrário
   */
  static isConferidor(token: string): boolean {
    if (!token) {
      return false;
    }
    const decoded = this.decodeToken(token);
    return decoded && decoded.isConferidor === 1;
  }
}












